import { SectionMods } from '~components/Section/Section.types';
import { SectionSubscribe } from '~components/SectionSubscribe/SectionSubscribe';
import { SectionSubscribeMods } from '~components/SectionSubscribe/SectionSubscribe.types';
import { ArticlePageContentBlocksProps } from '~containers/ArticlePage/ArticlePageContentBlocks/ArticlePageContentBlocks.types';
import { ContentBlockAccordion } from '~containers/ArticlePage/ContentBlockAccordion/ContentBlockAccordion';
import { ContentBlockBanner } from '~containers/ArticlePage/ContentBlockBanner/ContentBlockBanner';
import { ContentBlockDivider } from '~containers/ArticlePage/ContentBlockDivider/ContentBlockDivider';
import { ContentBlockFaq } from '~containers/ArticlePage/ContentBlockFaq/ContentBlockFaq';
import { ContentBlockForm } from '~containers/ArticlePage/ContentBlockForm/ContentBlockForm';
import { ContentBlockImages } from '~containers/ArticlePage/ContentBlockImages/ContentBlockImages';
import { ContentBlockImportant } from '~containers/ArticlePage/ContentBlockImportant/ContentBlockImportant';
import { ContentBlockQuote } from '~containers/ArticlePage/ContentBlockQuote/ContentBlockQuote';
import { ContentBlockText } from '~containers/ArticlePage/ContentBlockText/ContentBlockText';
import { ContentBlockTextBgColor } from '~containers/ArticlePage/ContentBlockTextBgColor/ContentBlockTextBgColor';
import { ContentBlockVkVideo } from '~containers/ArticlePage/ContentBlockVkVideo/ContentBlockVkVideo';
import { ContentBlockYoutubeVideo } from '~containers/ArticlePage/ContentBlockYoutubeVideo/ContentBlockYoutubeVideo';
import { useBreakpoints } from '~hooks/useBreakpoints';
import { ArticlePageBlockComponent } from '~types/BlockComponent.types';

export function ArticlePageContentBlocks({
  content,
  registerSection,
  unregisterSection,
}: ArticlePageContentBlocksProps) {
  const [, { isDesktop }] = useBreakpoints();
  const sectionProps = { registerSection, unregisterSection };
  return (
    <>
      {content?.map((block, key) => {
        switch (block.component) {
          case ArticlePageBlockComponent.SectionBanner:
            return (
              <ContentBlockBanner
                {...block}
                key={key}
                mods={[SectionMods.SeparatorM]}
                {...sectionProps}
              />
            );
          case ArticlePageBlockComponent.SectionText:
            return (
              <ContentBlockText
                {...block}
                key={key}
                mods={[SectionMods.SeparatorM]}
                {...sectionProps}
              />
            );
          case ArticlePageBlockComponent.SectionQuotes:
            return (
              <ContentBlockQuote
                {...block}
                key={key}
                mods={[SectionMods.SeparatorS]}
                {...sectionProps}
              />
            );
          case ArticlePageBlockComponent.SectionTextBgColor:
            return (
              <ContentBlockTextBgColor
                {...block}
                {...sectionProps}
                key={key}
                mods={[SectionMods.SeparatorS]}
              />
            );
          case ArticlePageBlockComponent.SectionImportant:
            return (
              <ContentBlockImportant
                {...block}
                {...sectionProps}
                key={key}
                mods={[SectionMods.SeparatorS]}
              />
            );
          case ArticlePageBlockComponent.SectionImages:
            return (
              <ContentBlockImages
                {...block}
                {...sectionProps}
                key={key}
                mods={[SectionMods.SeparatorM]}
              />
            );
          case ArticlePageBlockComponent.YoutubeVideo:
            return (
              <ContentBlockYoutubeVideo
                {...block}
                {...sectionProps}
                key={key}
                mods={[SectionMods.SeparatorM]}
              />
            );
          case ArticlePageBlockComponent.VkVideo:
            return (
              <ContentBlockVkVideo
                {...block}
                {...sectionProps}
                key={key}
                mods={[SectionMods.SeparatorM]}
              />
            );
          case ArticlePageBlockComponent.SectionDivider:
            return (
              <ContentBlockDivider
                {...block}
                {...sectionProps}
                key={key}
                mods={[SectionMods.SeparatorS]}
              />
            );
          case ArticlePageBlockComponent.SectionAccordion:
            return (
              <ContentBlockAccordion
                {...block}
                {...sectionProps}
                key={key}
                mods={[SectionMods.SeparatorS]}
              />
            );
          case ArticlePageBlockComponent.SectionFaq:
            return (
              <ContentBlockFaq
                {...block}
                {...sectionProps}
                key={key}
                mods={[SectionMods.SeparatorS]}
              />
            );
          case ArticlePageBlockComponent.SectionForm:
            return (
              <ContentBlockForm
                {...block}
                {...sectionProps}
                key={key}
                mods={[SectionMods.SeparatorM]}
              />
            );
          case ArticlePageBlockComponent.SectionSubscribe:
            return !isDesktop ? (
              <SectionSubscribe
                {...block}
                {...sectionProps}
                key={key}
                blockMods={[SectionSubscribeMods.Small]}
                mods={[SectionMods.SeparatorL]}
              />
            ) : null;
          default:
            return undefined;
        }
      })}
    </>
  );
}
